var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tabs',{staticClass:"NurseHome",attrs:{"tabs":_vm.nurseHomeTabs,"activeTabID":_vm.activeTabID,"transition":""},on:{"updateActiveTabID":_vm.updateActiveTabID}})
}
var staticRenderFns = []

export { render, staticRenderFns }